import React, {PropsWithChildren} from 'react';
import {Layout} from "./Layout";
import {Link, useLocation} from "react-router-dom";
import {Users, Database} from "lucide-react";

export const AdminLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();

    const menuItems = [
        { path: '/admin/users', icon: Users, label: 'Users' },
        { path: '/admin/sessions', icon: Database, label: 'Sessions' },
    ];

    return (
        <Layout>
            <div className="flex gap-6">
                {/* Sidebar */}
                <aside className="w-64 flex-shrink-0">
                    <nav className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
                        <div className="space-y-1">
                            {menuItems.map((item) => {
                                const Icon = item.icon;
                                const isActive = location.pathname === item.path;
                                
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                                            isActive
                                                ? 'bg-indigo-50 text-indigo-600 font-medium'
                                                : 'text-gray-700 hover:bg-gray-50'
                                        }`}
                                    >
                                        <Icon className={`h-5 w-5 mr-3 ${isActive ? 'text-indigo-600' : 'text-gray-400'}`} />
                                        {item.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </nav>
                </aside>

                {/* Main Content */}
                <main className="flex-1 min-w-0">
                    {children}
                </main>
            </div>
        </Layout>
    );
};
